import './firebase-app';
import {
  connectFirestoreEmulator,
  getFirestore,
  Timestamp,
} from 'firebase/firestore';

import { setTimestampFactory } from '@scaffold/common';

const firestore = getFirestore();

setTimestampFactory(Timestamp);

if (import.meta.env.DEV && import.meta.env.VITE_FIRESTORE_PORT)
  connectFirestoreEmulator(
    firestore,
    'localhost',
    +import.meta.env.VITE_FIRESTORE_PORT,
  );
